import React, { useState } from 'react'
import {
  Button,
  Icon,
  Modal,
  Header,
  Segment,
  Grid,
  Divider,
} from 'semantic-ui-react'
import { storageAPI } from '../../utils/api'
import { FileObject } from '../../utils/models'
import { QRCode } from 'react-qrcode-logo'
import Clipboard from 'react-clipboard.js'
import { observer } from '../../stores'
import { useTranslation } from 'react-i18next'
import { useMobile } from '../../hooks'
export interface ShareButtonProps {
  file: FileObject
}

export interface ShareButtonState {
  modalOpen: boolean
  deleting: boolean
  fileURL: string
}

const ShareButton = observer((props: ShareButtonProps) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [fileURL, setFileURL] = useState<string>('')
  const isMobile = useMobile()

  const { t } = useTranslation()

  const handleModalOpen = async () => {
    setModalOpen(true)
    setFileURL('')
    const fileURL = await storageAPI.downloadFile(props.file.Key!)
    const shortURL = await storageAPI.getShareURL(fileURL)
    setFileURL(shortURL)
  }

  const handleModalClose = () => setModalOpen(false)

  return (
    <Modal
      trigger={
        <Button
          className="share-button"
          icon
          circular
          basic
          color="yellow"
          onClick={handleModalOpen}
        >
          <Icon name="share alternate" />
        </Button>
      }
      open={modalOpen}
      onClose={handleModalClose}
      closeIcon
      size="small"
    >
      <Header icon="share alternate" content={t('shareFiles')} />
      <Modal.Content>
        {fileURL ? (
          <Segment placeholder>
            <Grid columns={2} stackable textAlign="center">
              {isMobile !== 'isMobile' && <Divider vertical>Or</Divider>}

              <Grid.Row verticalAlign="middle">
                <Grid.Column>
                  <QRCode
                    value={fileURL}
                    qrStyle="dots"
                    fgColor="orange"
                    bgColor="transparent"
                    logoImage="logo2.png"
                    logoWidth={60}
                    logoHeight={50}
                  />
                </Grid.Column>

                <Grid.Column>
                  <Header icon>
                    <Icon name="linkify" color="yellow" />
                    <br />
                    <a href={fileURL} target="_blank" rel="noopener noreferrer">
                      {fileURL}
                    </a>
                  </Header>
                  <Clipboard
                    data-clipboard-text={fileURL}
                    className="ui yellow button"
                  >
                    {t('copy')}
                  </Clipboard>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        ) : (
          <Segment placeholder>
            <Header icon>
              <Icon name="spinner" loading color="yellow" />
              {t('generatingSharingLinks')} ...
            </Header>
          </Segment>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button color="yellow" basic onClick={handleModalClose}>
          <Icon name="remove" /> {t('cancel')}
        </Button>
      </Modal.Actions>
    </Modal>
  )
})

export default ShareButton
